var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading',{attrs:{"active":_vm.isLoading,"can-cancel":false,"is-full-page":true,"z-index":99999}})}
var staticRenderFns = []

export { render, staticRenderFns }